export default "__VITE_ASSET__9MF$9UnG__"